import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useSession } from "@/app/session.tsx";
import { setLanguage, type Language } from "@/i18n/index.ts";
import { Button } from "./primitives.tsx";

export function TopBar() {
  const { t, i18n } = useTranslation();
  const { user, signOut } = useSession();

  return (
    <header className="topbar">
      <Link to="/" className="brand" style={{ textDecoration: "none", color: "inherit" }}>
        <span className="brand-mark" aria-hidden="true">
          PA
        </span>
        <span className="brand-name">{t("app.name")}</span>
      </Link>

      <nav className="tabs" aria-label={t("app.name")} style={{ marginLeft: "var(--s5)" }}>
        <Link to="/studio" className="tab">
          {t("nav.studio")}
        </Link>
        <Link to="/collections" className="tab">
          {t("nav.collections")}
        </Link>
        <Link to="/library" className="tab">
          {t("nav.library")}
        </Link>
        {user?.role === "admin" || user?.role === "operator" ? (
          <Link to="/query-trends" className="tab">
            {t("nav.trends")}
          </Link>
        ) : null}
      </nav>

      <span className="spacer" />

      <select
        aria-label="Bahasa"
        className="input"
        style={{ width: 78, height: 28 }}
        value={i18n.language.startsWith("en") ? "en" : "id"}
        onChange={(event) => setLanguage(event.target.value as Language)}
      >
        <option value="id">ID</option>
        <option value="en">EN</option>
      </select>

      {user ? (
        <Button size="sm" variant="ghost" onClick={() => void signOut()}>
          {t("nav.signOut")}
        </Button>
      ) : null}
    </header>
  );
}
